import axios from 'axios'
import store from '@/store'
import config from '@/config'

export const apiClient = axios.create({
  baseURL: config.api_url,
  headers: { 'Content-Type': 'application/json' },
})

apiClient.interceptors.request.use(request => {
  if (store.state.user.accessToken) {
    request.headers.Authorization = `Bearer ${store.state.user.accessToken}`
  }
  return request
})

export default apiClient
